




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import { DATA } from '@/config/data';
import u from '@/utility/utility';
import DeliveryInfo from './components/DeliveryInfo.vue';
import ListOrder from './components/ListOrder.vue';
import { BillOfLadingModel } from '@/models/bill-of-lading';
import { Customer } from '@/models/customer';
import { PaymentRequestModel } from '@/models/payment-request';
import authService from '@/services/auth-services';
import orderService from '@/services/order-service';
import formatNumber from '@/shared/filters/format-number';
import paymentRequestServices from '@/services/payment-request-services';

@Component({
    components: {
        Loading,
        'delivery-info': DeliveryInfo,
        'list-order': ListOrder
    }
})
export default class DetailPaymentRequest extends Vue {
    private paymentRequest: PaymentRequestModel = new PaymentRequestModel();
    private listPackages: BillOfLadingModel[] = [];
    private customerInfo: Customer = {};
    private isLoading = false;

    get requestId() {
        return this.$route.params.id;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get totalChoose() {
        return this.listPackages.length;
    }

    @Watch('requestId', { immediate: true, deep: true })
    private async watchOrderId() {
        if (this.requestId) {
            this.loadData();
        }
    }

    private getStatus(value: any) {
        return DATA.billOfLadingStatus.find(x => x.value === value) || { value: 0, name: 'N/A', color: '#49494a' };
    }

    private async loadData() {
        if (this.requestId) {
            const result = await paymentRequestServices.getPaymentRequestByID(this.requestId);
            this.listPackages = [];
            if (result && result.status === 200 && (result.data.data.length > 0 || result.data.data.ID > 0)) {
                const ret = result.data.data;
                this.paymentRequest = new PaymentRequestModel();
                this.paymentRequest.id = ret.ID;
                this.paymentRequest.status = ret.Status;
                this.paymentRequest.statusDetail = DATA.requestPaymentStatus.find(x => x.value === ret.Status) || { value: 0, name: 'Khác', color: '#3b4354' };
                this.paymentRequest.numberOfPack = ret.NumberOfPack;
                this.paymentRequest.uId = ret.UID;
                this.paymentRequest.userName = ret.Username;
                this.paymentRequest.phone = ret.Phone;
                this.paymentRequest.address = ret.Address;
                this.paymentRequest.note = ret.Note;
                const tmpListOrder: BillOfLadingModel[] = [];
                for (const item of ret.Packages) {
                    const order = new BillOfLadingModel();
                    order.id = item.ID;
                    order.status = item.Status;
                    order.statusDetail = this.getStatus(item.Status);
                    order.orderTransactionCode = item.OrderTransactionCode;
                    order.weight = item.Weight > 0 ? `${formatNumber(item.Weight, '0,0.[0000]')} kg` : '';
                    order.volume = item.Volume > 0 ? `${formatNumber(item.Volume, '0,0.[0000]')} m3` : '';
                    tmpListOrder.push(order);
                }
                this.listPackages = tmpListOrder;
            }
        }
    }
}
